import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'reset-password',
        path: `${AUTH_PREFIX_PATH}/reset-password`,
        component: React.lazy(() => import('views/auth-views/authentication/reset-password')),
    },
    {
        key: 'error-page-1',
        path: `${AUTH_PREFIX_PATH}/error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'error-page-2',
        path: `${AUTH_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    },
]

const CUSTOMER = ['CUSTOMER']
const STAFF = ['STAFF', 'ADMIN']
const ADMIN = ['ADMIN']

export const protectedRoutes = [
    // ---------- Customer portal ----------
    {
        key: 'portal.dashboard',
        path: `${APP_PREFIX_PATH}/portal/dashboard`,
        component: React.lazy(() => import('views/app-views/portal/dashboard')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.savings',
        path: `${APP_PREFIX_PATH}/portal/savings`,
        component: React.lazy(() => import('views/app-views/portal/savings')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.savings.detail',
        path: `${APP_PREFIX_PATH}/portal/savings/:id`,
        component: React.lazy(() => import('views/app-views/portal/savings-detail')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.shares',
        path: `${APP_PREFIX_PATH}/portal/shares`,
        component: React.lazy(() => import('views/app-views/portal/shares')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.shares.detail',
        path: `${APP_PREFIX_PATH}/portal/shares/:id`,
        component: React.lazy(() => import('views/app-views/portal/shares-detail')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.loans',
        path: `${APP_PREFIX_PATH}/portal/loans`,
        component: React.lazy(() => import('views/app-views/portal/loans')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.loans.apply',
        path: `${APP_PREFIX_PATH}/portal/loans/apply`,
        component: React.lazy(() => import('views/app-views/portal/loan-apply')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.loans.detail',
        path: `${APP_PREFIX_PATH}/portal/loans/:id`,
        component: React.lazy(() => import('views/app-views/portal/loan-detail')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.statements',
        path: `${APP_PREFIX_PATH}/portal/statements`,
        component: React.lazy(() => import('views/app-views/portal/statements')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.concerns',
        path: `${APP_PREFIX_PATH}/portal/concerns`,
        component: React.lazy(() => import('views/app-views/portal/concerns')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.concerns.detail',
        path: `${APP_PREFIX_PATH}/portal/concerns/:id`,
        component: React.lazy(() => import('views/app-views/portal/concern-detail')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.profile',
        path: `${APP_PREFIX_PATH}/portal/profile`,
        component: React.lazy(() => import('views/app-views/portal/profile')),
        meta: { roles: CUSTOMER },
    },
    {
        key: 'portal.payments',
        path: `${APP_PREFIX_PATH}/portal/payments`,
        component: React.lazy(() => import('views/app-views/portal/payments')),
        meta: { roles: CUSTOMER },
    },

    // ---------- Portfolio (staff + admin) ----------
    {
        key: 'portfolio',
        path: `${APP_PREFIX_PATH}/portfolio`,
        component: React.lazy(() => import('views/app-views/portfolio')),
        meta: { roles: STAFF },
    },

    // ---------- Staff back office ----------
    {
        key: 'staff.approvals',
        path: `${APP_PREFIX_PATH}/staff/approvals`,
        component: React.lazy(() => import('views/app-views/staff/approvals')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.members',
        path: `${APP_PREFIX_PATH}/staff/members`,
        component: React.lazy(() => import('views/app-views/staff/members')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.members.recruit',
        path: `${APP_PREFIX_PATH}/staff/members/recruit`,
        component: React.lazy(() => import('views/app-views/staff/member-recruit')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.members.detail',
        path: `${APP_PREFIX_PATH}/staff/members/:id`,
        component: React.lazy(() => import('views/app-views/staff/member-detail')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.loan-applications',
        path: `${APP_PREFIX_PATH}/staff/loan-applications`,
        component: React.lazy(() => import('views/app-views/staff/loan-applications')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.loan-applications.detail',
        path: `${APP_PREFIX_PATH}/staff/loan-applications/:id`,
        component: React.lazy(() => import('views/app-views/staff/loan-application-detail')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.loans',
        path: `${APP_PREFIX_PATH}/staff/loans`,
        component: React.lazy(() => import('views/app-views/staff/loans')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.loans.detail',
        path: `${APP_PREFIX_PATH}/staff/loans/:id`,
        component: React.lazy(() => import('views/app-views/staff/loan-detail')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.savings',
        path: `${APP_PREFIX_PATH}/staff/savings`,
        component: React.lazy(() => import('views/app-views/staff/savings')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.messaging',
        path: `${APP_PREFIX_PATH}/staff/messaging`,
        component: React.lazy(() => import('views/app-views/staff/messaging')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.shares',
        path: `${APP_PREFIX_PATH}/staff/shares`,
        component: React.lazy(() => import('views/app-views/staff/shares')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.concerns',
        path: `${APP_PREFIX_PATH}/staff/concerns`,
        component: React.lazy(() => import('views/app-views/staff/concerns')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.concerns.detail',
        path: `${APP_PREFIX_PATH}/staff/concerns/:id`,
        component: React.lazy(() => import('views/app-views/staff/concern-detail')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.statements',
        path: `${APP_PREFIX_PATH}/staff/statements`,
        component: React.lazy(() => import('views/app-views/staff/statements')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.fees',
        path: `${APP_PREFIX_PATH}/staff/fees`,
        component: React.lazy(() => import('views/app-views/staff/fees')),
        meta: { roles: STAFF },
    },
    {
        key: 'staff.mpesa-transactions',
        path: `${APP_PREFIX_PATH}/staff/mpesa-transactions`,
        component: React.lazy(() => import('views/app-views/staff/mpesa-transactions')),
        meta: { roles: STAFF },
    },

    // ---------- Admin ----------
    {
        key: 'admin.dashboard',
        path: `${APP_PREFIX_PATH}/admin/dashboard`,
        component: React.lazy(() => import('views/app-views/admin/dashboard')),
        meta: { roles: STAFF },
    },
    {
        key: 'admin.users',
        path: `${APP_PREFIX_PATH}/admin/users`,
        component: React.lazy(() => import('views/app-views/admin/users')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.loan-products',
        path: `${APP_PREFIX_PATH}/admin/loan-products`,
        component: React.lazy(() => import('views/app-views/admin/loan-products')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.savings-products',
        path: `${APP_PREFIX_PATH}/admin/savings-products`,
        component: React.lazy(() => import('views/app-views/admin/savings-products')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.share-products',
        path: `${APP_PREFIX_PATH}/admin/share-products`,
        component: React.lazy(() => import('views/app-views/admin/share-products')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.books',
        path: `${APP_PREFIX_PATH}/admin/books`,
        component: React.lazy(() => import('views/app-views/admin/books')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.statement-pricing',
        path: `${APP_PREFIX_PATH}/admin/statement-pricing`,
        component: React.lazy(() => import('views/app-views/admin/statement-pricing')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.mpesa-config',
        path: `${APP_PREFIX_PATH}/admin/mpesa-config`,
        component: React.lazy(() => import('views/app-views/admin/mpesa-config')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.sms-config',
        path: `${APP_PREFIX_PATH}/admin/sms-config`,
        component: React.lazy(() => import('views/app-views/admin/sms-config')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.mobile-app',
        path: `${APP_PREFIX_PATH}/admin/mobile-app`,
        component: React.lazy(() => import('views/app-views/admin/mobile-app')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.notification-settings',
        path: `${APP_PREFIX_PATH}/admin/notification-settings`,
        component: React.lazy(() => import('views/app-views/admin/notification-settings')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.audit-log',
        path: `${APP_PREFIX_PATH}/admin/audit-log`,
        component: React.lazy(() => import('views/app-views/admin/audit-log')),
        meta: { roles: ADMIN },
    },
    {
        key: 'admin.reports',
        path: `${APP_PREFIX_PATH}/admin/reports`,
        component: React.lazy(() => import('views/app-views/admin/reports')),
        meta: { roles: ADMIN },
    },

    // ---------- Shared ----------
    {
        key: 'account.change-password',
        path: `${APP_PREFIX_PATH}/account/change-password`,
        component: React.lazy(() => import('views/app-views/account/change-password')),
    },
]

// Legal pages must work for a signed-out visitor (Google Play's reviewer, a prospective member,
// a member who forgot their password) -- neither protectedRoutes (requires login) nor
// publicRoutes (redirects AWAY if already logged in, since that group is login/register) fits.
// Rendered unconditionally in routes/index.js, with blankLayout so it doesn't assume the
// authenticated app shell.
export const alwaysAccessibleRoutes = [
    {
        key: 'legal.terms',
        path: `${APP_PREFIX_PATH}/legal/terms`,
        component: React.lazy(() => import('views/app-views/legal/terms')),
        meta: { blankLayout: true },
    },
    {
        key: 'legal.privacy',
        path: `${APP_PREFIX_PATH}/legal/privacy`,
        component: React.lazy(() => import('views/app-views/legal/privacy')),
        meta: { blankLayout: true },
    },
    {
        key: 'legal.code-of-conduct',
        path: `${APP_PREFIX_PATH}/legal/code-of-conduct`,
        component: React.lazy(() => import('views/app-views/legal/code-of-conduct')),
        meta: { blankLayout: true },
    },
    {
        key: 'legal.delete-account',
        path: `${APP_PREFIX_PATH}/legal/delete-account`,
        component: React.lazy(() => import('views/app-views/legal/delete-account')),
        meta: { blankLayout: true },
    },
]
